import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";

import classes from "../../PublicationListSelectionSlide.module.scss";
import { BrandgenListDomain } from "../../../../../types/campaignTypes";

type DomainListProps = {
  domainList: BrandgenListDomain[];
};

const DomainList: FC<DomainListProps> = ({ domainList }) => {
  return (
    <div className={classes.domainList}>
      {domainList.map(({ id, name }, index) => (
        <Typography key={id} className={classes.domainList}>
          <a href={`https://${name}`} target="_blank" rel="noopener noreferrer">
            {name}
          </a>
          {index === domainList.length - 1 ? "" : ","}
        </Typography>
      ))}
    </div>
  );
};

export default DomainList;
